export default __webpack_public_path__ + "static/media/Informationicon.60e63449.svg";